import { initReactQueryAuth } from './react-query-auth';

import { Spinner } from '@/components/Elements';
import {
  loginWithEmailAndPassword,
  getUser,
  registerWithEmailAndPassword,
} from '@/features/auth';
import storage from '@/utils/storage';
import { updateUser } from '@/features/auth/api/updateUser';
import { ROLES } from './authorization';
import { logoutUser } from '@/features/auth/api/logout.api';
import { jwtDecode } from 'jwt-decode';
import { googleLogin } from '@/features/auth/api/googleLogin';

async function handleUserResponse(data) {
  const { access_token } = data;
  storage.setToken(access_token);
  const user = await loadUser();
  return user;
}

async function loadUser() {
  const token = storage.getToken();
  if (token) {
    const decodedToken = jwtDecode(token);
    const { role, userId, tenantId } = decodedToken;

    if (storage.getToken()) {
      return {
        id: userId,
        role,
        tenantId,
      };
    }
    return null;
  }
}

async function loginFn(data) {
  try {
    const response = await loginWithEmailAndPassword(data);
    const user = await handleUserResponse(response);
    localStorage.setItem('email', data?.username);
    return user;
  } catch (error) {}
}

async function googleLoginFn(data) {
  try {
    const response = await googleLogin(data);
    const user = await handleUserResponse(response);
    localStorage.setItem('email', response.email);
    return user;
  } catch (error) {}
}

async function registerFn(data) {
  const response = await registerWithEmailAndPassword(data);
  // const user = await handleUserResponse(response);
  // return user;
}

async function logoutFn() {
  await logoutUser();
  localStorage.clear();
  window.dispatchEvent(
    new CustomEvent('logout', { detail: { navigateTo: '/auth/login' } })
  );
}

async function updateUserFn({ userId, data }) {
  await updateUser(userId, data);
  return data;
}

const authConfig = {
  loadUser,
  loginFn,
  registerFn,
  logoutFn,
  updateUserFn,
  googleLoginFn,
  LoaderComponent() {
    return (
      <div className="w-screen h-screen flex justify-center items-center">
        <Spinner size="xl" />
      </div>
    );
  },
};

export const { AuthProvider, useAuth } = initReactQueryAuth(authConfig);
